// src/services/lastConversation.ts
//
// Remembers the conversation the user was last looking at, so going
// back to the chat tab resumes that conversation rather than starting
// fresh. Per-uid, localStorage-only — survives reloads but not
// reinstalls. Cross-device continuation isn't a goal here; tourists
// don't typically swap devices mid-trip.

const KEY_PREFIX = 'instantTours:lastConversationId:';

export function getLastConversationId(uid: string | null | undefined): string | null {
  if (!uid) return null;
  try {
    return localStorage.getItem(KEY_PREFIX + uid);
  } catch {
    return null;
  }
}

export function setLastConversationId(
  uid: string | null | undefined,
  conversationId: string | null
): void {
  if (!uid) return;
  try {
    if (conversationId) {
      localStorage.setItem(KEY_PREFIX + uid, conversationId);
    } else {
      localStorage.removeItem(KEY_PREFIX + uid);
    }
  } catch {
    // ignore quota errors etc.
  }
}

export function clearLastConversationId(uid: string | null | undefined): void {
  setLastConversationId(uid, null);
}
